import SurveyIcon from './assets/SurveyIcons-0.svg';
import SurveyIcon1 from './assets/SurveyIcons-1.svg';
import SurveyIcon10 from './assets/SurveyIcons-10.svg';
import SurveyIcon11 from './assets/SurveyIcons-11.svg';
import SurveyIcon12 from './assets/SurveyIcons-12.svg';
import SurveyIcon13 from './assets/SurveyIcons-13.svg';
import SurveyIcon14 from './assets/SurveyIcons-14.svg';
import SurveyIcon15 from './assets/SurveyIcons-15.svg';
import SurveyIcon16 from './assets/SurveyIcons-16.svg';
import SurveyIcon17 from './assets/SurveyIcons-17.svg';
import SurveyIcon18 from './assets/SurveyIcons-18.svg';
import SurveyIcon19 from './assets/SurveyIcons-19.svg';
import SurveyIcon2 from './assets/SurveyIcons-2.svg';
import SurveyIcon20 from './assets/SurveyIcons-20.svg';
import SurveyIcon21 from './assets/SurveyIcons-21.svg';
import SurveyIcon22 from './assets/SurveyIcons-22.svg';
import SurveyIcon3 from './assets/SurveyIcons-3.svg';
import SurveyIcon4 from './assets/SurveyIcons-4.svg';
import SurveyIcon5 from './assets/SurveyIcons-5.svg';
import SurveyIcon6 from './assets/SurveyIcons-6.svg';
import SurveyIcon7 from './assets/SurveyIcons-7.svg';
import SurveyIcon8 from './assets/SurveyIcons-8.svg';
import SurveyIcon9 from './assets/SurveyIcons-9.svg';

interface SurveyType {
  tags: string[];
  icon: React.ElementType;
}

const DEFAULT: SurveyType = {
  tags: [],
  icon: SurveyIcon,
};

export const TYPES: SurveyType[] = [
  { tags: ['type-15', 'spending_diary', 'visa_diary'], icon: SurveyIcon15 },
  {
    tags: ['type-14', 'my_personal_routine', 'mypersonalroutine'],
    icon: SurveyIcon14,
  },
  { tags: ['type-0'], icon: SurveyIcon1 },
  { tags: ['type-1', 'product_test'], icon: SurveyIcon1 },
  { tags: ['type-2', 'continuous_diary', 'diaries'], icon: SurveyIcon2 },
  { tags: ['type-3', 'daily_diary'], icon: SurveyIcon3 },
  { tags: ['type-4', 'teens'], icon: SurveyIcon4 },
  { tags: ['type-5', 'together_with_child'], icon: SurveyIcon5 },
  { tags: ['type-6', 'only_available_today'], icon: SurveyIcon6 },
  { tags: ['type-7', 'recall'], icon: SurveyIcon7 },
  {
    tags: ['type-8', 'technical_issues_fixed'],
    icon: SurveyIcon8,
  },
  { tags: ['type-9', 'other'], icon: SurveyIcon9 },
  {
    tags: ['type-10', 'engagement'],
    icon: SurveyIcon10,
  },
  {
    tags: ['type-11', 'profiler', 'screener'],
    icon: SurveyIcon11,
  },
  {
    tags: ['type-12', 'health_care_profiler'],
    icon: SurveyIcon12,
  },
  { tags: ['type-13', 'my_telco', 'comtech'], icon: SurveyIcon13 },
  {
    tags: ['type-16', 'life_connect'],
    icon: SurveyIcon16,
  },
  { tags: ['type-17', 'social'], icon: SurveyIcon17 },
  { tags: ['type-18', 'political'], icon: SurveyIcon18 },
  { tags: ['type-19', 'my_lifestyle'], icon: SurveyIcon19 },
  { tags: ['type-20', 'consent'], icon: SurveyIcon20 },
  {
    tags: ['type-21', 'camera_study', 'webcam'],
    icon: SurveyIcon21,
  },
  { tags: ['type-22', 'bright_labs', 'brightlabs'], icon: SurveyIcon22 },
];

export function findSurveyType(tags: readonly string[]): SurveyType {
  return TYPES.find((i) => i.tags.find((t) => tags.includes(t))) || DEFAULT;
}
